


































export default function (Component) {
  Component.options.__source = "src/module/components/lolth-explorer/renderer/cmp-qty-details-cell-renderer.vue"
}
